import {useContext, useEffect, useState} from "react";
import "./calendar.css";
import Scripts from "../../Common/Scripts/Scripts";
import CandidateSidebar from "../Dashboard/CandidateSidebar";
import Footer from "../Dashboard/Footer";
import Header from "../Dashboard/Header";
import {getSession} from "../../../utils/session";
import {EMPLOYR_LOGIN_SESSION} from "../../../constant/session";
import {ROLE} from "../../../constant/role";
import CareHomeSidebar from "../Dashboard/CareHomeSideBar";
import {del, get, post, put} from "../../../api";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Loading from "../../Common/Loading";
import Loader from "../../Common/Loading";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import Success from "../../Common/Alert/Success";
import Error from "../../Common/Alert/Error";
import {useForm} from "react-hook-form";
import {InputError} from "../../Common/FormControl/Input";
import {formatDate, formatDateHyphen, getTimeFromDate, isPastdate} from "../../../utils/date";
import {scrollTop} from "../../../utils/scroll";
import $ from "jquery";
import {AuthContext} from "../../../context/auth";
import {useSearchParams} from "react-router-dom";
import {TimePicker} from "../../Common/TimePicker/Timepicker"


const Meetings = () => {
  const [user, setUser] = useState();
  const [userDetail, setUserDetail] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [meetingURL, setMeetingURL] = useState("");
  const [jobApplicationStatus, setJobApplicationStatus] = useState("");
  const [jobs, setJobs] = useState([]);
  const [users, setUsers] = useState([]);
  const [jobVal, setJobval] = useState({ title: "" });
  const [userVal, setUserval] = useState({ name: "" });
  const [descriptionVal, setDescriptionVal] = useState("");
  const [meetingCountDetail, setMeetingCountDetail] = useState([]);
  const [clickedDate, setClickedDate] = useState(undefined);
  const [meetingDetailPerDate, setMeetingDetailPerDate] = useState([]);
  const [meetingDetailPerUser, setMeetingDetailPerUser] = useState([]);
  const [timeValue, setTimeValue] = useState("");
  const [meetingNotes, setMeetingNotes] = useState("");
  const [meetingUserStatus, setMeetingUserStatus] = useState(false);
  const [sentInviteFlag, setSentInviteFlag] = useState("");
  const [acceptRejectStatus, setAcceptRejectStatus] = useState("");
  const [deleteMeetingStatus, setDeleteMeetingStatus] = useState("");
  const [fromUserName, setFromUserName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [calendarMonth, setCalendarMonthsDates] = useState();
  const { register, getValues, setValue, formState } = useForm();
  const addMeetingNoteError = formState.errors;
  const candidateMeetignForm = useForm();
  const candidateError = candidateMeetignForm.formState.errors;
  const { setUnreadMessages } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const meetingIdParam = searchParams.get("meetingId");
  const dateParam = searchParams.get("date");


  const isAcceptedMeeting = meetingDetailPerUser[0]?.status === "Accepted";
  const isCareHome = user?.role === ROLE.CARE_HOME;
  const setupMeetingForm = useForm({
    defaultValues: {
      meetingtime: "" // Initialize with empty string
    }
  });

  const {
    formState: { errors },
  } = setupMeetingForm;



  useEffect(() => {
    window.setTimeout(async () => {
      await window.dispatchEvent(new Event("resize"));
    }, 1000);
    const session = getSession(EMPLOYR_LOGIN_SESSION);
    setUser(session);
    callMethod();
    getMeetingDetailsInit();
    const updatedTIme = new Date();
    const month = Number(updatedTIme?.getMonth()) + 1;
    const year = updatedTIme.getFullYear();
    const payload = {
      monthNumber: month,
      year: year,
    };
    getMeetingCounts(payload);
  }, []);

  const getMessageCount = async () => {
    const url = `/user/stats/count`;
    try {
      const response = await get(url);
      setUnreadMessages(response?.unreadMsg);
    } catch (e) {
      console.error(e);
    }
  };

  const getMeetingDetailsInit = () => {
    if (meetingIdParam && dateParam) {
      const [yyyy, mm, dd] = dateParam?.split("-");
      const paramDate = `${mm}-${dd}-${yyyy}`;
      getMeetingByDate(formatDate(paramDate));
      getMeetingById({ id: meetingIdParam });
    } else {
      getMeetingByDate(formatDate(new Date()));
    }
  };

  const resetData = () => {
    setClickedDate(undefined);
    setJobval({ title: "" });
    setUserval({ name: "" });
    setTimeValue("");
    setDescriptionVal("");
    setMeetingNotes("");
    setMeetingUserStatus("");
    setDeleteMeetingStatus("");
  };

  const getMeetingCounts = async (dates) => {
    const { monthNumber, year } = dates;
    const type = user?.role || JSON.parse(localStorage.getItem(EMPLOYR_LOGIN_SESSION))?.role;
    try {
      if (type) {
        const url = `/meeting-timesheet/meeting/count?month=${monthNumber}&year=${year}&type=${type}`;
        const response1 = await get(url);
        var calanderData = [];
        for (let [key, value] of Object.entries(response1?.meetings)) {
          if(!isPastdate(key)){
            calanderData.push({
              title: JSON.stringify({
                count: value?.count,
                timings: value?.timings,
              }),
              date: key,
              getDate: key,
            });
          }
        }
        setMeetingCountDetail(calanderData);
      }
    } catch (err) {
      console.log("Error is", err);
    }
  };

  const getMeetingById = async (meetingId) => {
    setMeetingURL("");
    const url = `/meeting-timesheet/meeting?meetingId=${meetingId?.id}`;
    setJobApplicationStatus("");
    const response = await get(url);
    setMeetingDetailPerUser(response);
    setMeetingNotes(response[0]?.meetingNotes);
    setClickedDate(response[0]?.meetingDate);
    setCompanyName(response[0]?.companyName);
    setMeetingUserStatus(response[0]?.status);
    const tVal = getTimeFromDate(response[0]?.meetingDateTime);
    setTimeValue(tVal);
    const getJobDetailUrl = `/job/jobs/${response?.[0]?.shiftId}?user-data=false`;
    const jobData = await get(getJobDetailUrl);

    if (user?.role === ROLE.CANDIDATE || JSON.parse(localStorage.getItem(EMPLOYR_LOGIN_SESSION))?.role === ROLE.CANDIDATE) {
      candidateMeetignForm.setValue("candidate", response[0]?.companyName, { shouldValidate: true });
      candidateMeetignForm.setValue("job", jobData?.title, { shouldValidate: true });
      candidateMeetignForm.setValue("meetingdate", response[0]?.meetingDate, { shouldValidate: true });
      candidateMeetignForm.setValue("meetingDescription", response[0]?.description || "");
      if(response[0]?.status === 'Accepted') {
        setMeetingURL(response[0]?.meetingURL || "");
      }
      candidateMeetignForm.setValue("meetingDetail", response[0]?.meetingDetail || "");
      candidateMeetignForm.setValue("meetingType", response[0]?.meetingType || "");
      candidateMeetignForm.setValue("meetingtime", getTimeFromDate(response[0]?.meetingDateTime), { shouldValidate: true });
      scrollTop(".view-schedule-candidate-section");
    }
    if (user?.role === ROLE.CARE_HOME || JSON.parse(localStorage.getItem(EMPLOYR_LOGIN_SESSION))?.role === ROLE.CARE_HOME) {
      setMeetingURL(response[0]?.meetingURL);
      setupMeetingForm.setValue("searchCandidate", response[0]?.fromUserName, { shouldValidate: true });
      setupMeetingForm.setValue("meetingDescription", response[0]?.description);
      setupMeetingForm.setValue("meetingDetail", response[0]?.meetingDetail);
      setupMeetingForm.setValue("meetingType", response[0]?.meetingType);
      setupMeetingForm.setValue("searchActiveJobs", jobData?.title, { shouldValidate: true });
      setupMeetingForm.setValue("meetingdate", response[0]?.meetingDate, { shouldValidate: true });
      setupMeetingForm.setValue("meetingtime", getTimeFromDate(response[0]?.meetingDateTime), { shouldValidate: true });
      const meetingDate = new Date(response[0]?.meetingDate);
      const currentdate = new Date();
      const Difference_In_Time = meetingDate.getTime() - currentdate.getTime();
      const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (Difference_In_Days < 0) {
        $(".addMeetingNoteSection").trigger("click");
      } else {
        $(".setupMeetingTab").trigger("click");
      }
    }
    setJobval({
      id: jobData?.id,
      title: jobData?.title,
      city: jobData?.company ? jobData?.company?.sites[0].city : "",
    });
    setDescriptionVal(jobData?.description);
    setUserval({ name: response[0]?.toUserName });
  };

  const sendMeetingInvite = async (data) => {
    setLoading(true);
    setSentInviteFlag("");
    setJobApplicationStatus("");
    setDeleteMeetingStatus("");
    try {
      const url = `/meeting-timesheet/meeting`;
      const cDate = new Date().toISOString();

      // Properly format the meetingDateTime
      const meetingDateTime = `${data.meetingdate}T${data.meetingtime}`;

      const responseData = {
        toUserId: userVal?.id,
        fromUserId: userDetail?.userId,
        companyId: userDetail?.company?.companyId,
        shiftId: data?.searchActiveJobs?.id,
        createdDate: cDate,
        meetingDate: `${data?.meetingdate}`,
        description: data?.meetingDescription,
        meetingType: data?.meetingType,
        meetingDetail: data?.meetingDetail,
        meetingDateTime: meetingDateTime, // Use the properly formatted datetime
        location: data?.searchActiveJobs?.siteCity,
        meetingNotes: "Meeting notes",
        status: "Scheduled",
        userStatus: userDetail?.status,
        meetingAction: "SEND_INVITE",
      };

      const response = await post(url, responseData);
      if (response?.status === 201 || response?.status === 200) {
        setSentInviteFlag("success");
        getMeetingCounts(calendarMonth);
        setMeetingDetailPerDate([]);
        resetData();
        getMessageCount();
      } else {
        setSentInviteFlag("error");
      }
      setLoading(false);
    } catch (err) {
      setSentInviteFlag("error");
      setLoading(false);
      console.log("Something Went Wrong", err);
    }
  };



  const deleteMeeting = async () => {
    try {
      setLoading(true);
      setAcceptRejectStatus("");
      setSentInviteFlag("");
      setJobApplicationStatus("");
      setDeleteMeetingStatus("");
      const url = `/meeting-timesheet/meeting?meetingId=${meetingDetailPerUser[0]?.id}`;
      const response = await del(url);
      if (response?.status === 200 || response?.status === 204) {
        getMeetingCounts(calendarMonth);
        setDeleteMeetingStatus("success");
        setMeetingDetailPerDate([]);
        setMeetingDetailPerUser([]);
        setLoading(false);
        getMessageCount();
      } else {
        setLoading(false);
        setDeleteMeetingStatus("error");
      }
    } catch (e) {
      setDeleteMeetingStatus("error");
      setLoading(true);
      console.error(e);
    }
  };

  const UpdateMeetingInvite = async (formValue) => {
    setLoading(true);
    setAcceptRejectStatus("");
    setSentInviteFlag("");
    setJobApplicationStatus("");
    setDeleteMeetingStatus("");
    try {
      const url = `/meeting-timesheet/meeting`;
      const updateData = {
        ...meetingDetailPerUser[0], // Spread existing meeting data
        meetingAction: formValue?.submitValue?.action,
        meetingNotes: getValues("meetingNotes"),
        description: formValue?.meetingDescription,
        meetingDetail: formValue?.meetingDetail,
        meetingType: formValue?.meetingType,
        meetingDate: formValue?.meetingdate,
        meetingDateTime: formatTimeForBackend(formValue?.meetingdate, formValue?.meetingtime),
        ...(formValue?.rejectionComments && {
          rejectionComments: formValue.rejectionComments
        }),
      };

      if (formValue?.submitValue?.status) {
        updateData.status = formValue?.submitValue?.status;
        if (formValue?.submitValue?.action === "SELECT_CANDIDATE") {
          updateData.joiningDate = formValue?.joiningDate
              ? new Date(formValue?.joiningDate).toISOString()
              : null;
          updateData.reportTime = formValue?.reportingTime
              ? formatTimeForBackend(formatDate(formValue?.joiningDate), formValue?.reportingTime)
              : null;

          if (!updateData.joiningDate && !updateData.reportTime) {
            setJobApplicationStatus("validationError");
            setLoading(false);
            return;
          }
        }
      }

      const response = await put(url, updateData);
      if (response?.status === 202 || response?.status === 201) {
        setAcceptRejectStatus("success");
        getMeetingCounts(calendarMonth);
        setMeetingDetailPerDate([]);
        resetData();
        getMessageCount();
      } else {
        setAcceptRejectStatus("error");
      }
    } catch (err) {
      setAcceptRejectStatus("error");
      console.error("Error updating meeting:", err);
    } finally {
      setLoading(false);
    }
  };

// Helper function to format time for backend
  const formatTimeForBackend = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return '';

    // Convert 12-hour format to 24-hour if needed
    let time24 = timeStr;
    if (timeStr.includes('PM') || timeStr.includes('AM')) {
      const [time, period] = timeStr.split(' ');
      let [hours, minutes] = time.split(':');

      if (period === 'PM' && hours !== '12') {
        hours = String(parseInt(hours, 10) + 12);
      } else if (period === 'AM' && hours === '12') {
        hours = '00';
      }

      time24 = `${hours.padStart(2, '0')}:${minutes}`;
    }

    // Return in ISO 8601 format with UTC timezone
    return `${dateStr}T${time24}:00.000Z`;
  };

  const callMethod = async () => {
    try {
      const url = `/user/users/detail`;
      const response = await get(url);
      setUserDetail(response);
      if (response?.role === ROLE.CARE_HOME) {
        getActiveJobs(response?.company?.companyId);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const getActiveJobs = async (companyId) => {
    setLoading(true);
    const url = `/job/jobs/company?companyId=${companyId}`;
    try {
      const response = await get(url);
      const filteredJob = response?.filter((itm) => !isPastdate(itm?.endDate));
      setJobs(filteredJob);
      setLoading(false);
    } catch (err) {
      console.log("Something Went Wrong", err);
    }
  };

  const handleDateClick = (e) => {
    resetData();
    setMeetingDetailPerDate([]);
    setClickedDate(e.dateStr);
    if (user?.role === ROLE.CANDIDATE) {
      candidateMeetignForm.setValue("meetingdate", e.dateStr, { shouldValidate: true });
    }
    if (user?.role === ROLE.CARE_HOME) {
      setupMeetingForm.setValue("meetingdate", e.dateStr, { shouldValidate: true });
    }
  };

  const msg = async (date) => {
    setClickedDate(date?._def?.extendedProps?.getDate);
    getMeetingByDate(date?._def?.extendedProps?.getDate);
  };

  const getMeetingByDate = async (date) => {
    try {
      const url = `/meeting-timesheet/meeting?date=${date}`;
      const response = await get(url);
      if (response) {
        setMeetingDetailPerDate(response?.reverse());
      }
    } catch (e) {
      console.error(e);
    }
  };

  function renderEventContent(eventInfo) {
    const { count, timings } = JSON.parse(eventInfo.event.title);
    return (
        <>
          {count > 3 ? (
              <p id="demo" style={{ color: "#ffffff" }} onClick={() => msg(eventInfo.event)}>
                {count}
              </p>
          ) : (
              <p id="demo" style={{ color: "#ffffff", lineHeight: "14px" }} onClick={() => msg(eventInfo.event)}>
                {timings?.map((itm, index) => (
                    <small>
                      {itm}
                      <br />
                    </small>
                ))}
              </p>
          )}
        </>
    );
  }

  const getCandidateByUser = async (jobId) => {
    try {
      if (jobId) {
        const url = `/job/jobs/${jobId}?user-data=true`;
        const response = await get(url);
        const res = [];
        if (response) {
          response?.jobApplicationApplicants?.forEach((itm) => {
            res.push({
              id: itm?.userId,
              name: `${itm?.firstName} ${itm?.lastName}`,
            });
          });
        }
        setUsers(res);
        setDescriptionVal(response?.description);
        setJobval({
          id: response?.id,
          title: response?.title,
          city: response?.company?.sites[0].city,
        });
      }
      setLoading(false);
    } catch (err) {
      console.log("Something Went Wrong", err);
    }
  };

  const getWeekDay = (date) => {
    const language = "en-us";
    const options = { weekday: "long" };
    if (date !== undefined) {
      return new Date(date).toLocaleString(language, options);
    } else {
      return new Date().toLocaleString(language, options);
    }
  };

  const getMonthFull = (date) => {
    const language = "en-us";
    const options = { month: "short" };
    if (date !== undefined) {
      return new Date(date).toLocaleString(language, options);
    } else {
      return new Date().toLocaleString(language, options);
    }
  };

  const getDate = (date) => {
    let d = "";
    if (date !== undefined) {
      d = new Date(date);
    } else {
      d = new Date();
    }
    return d.getDate();
  };

  const getTime = (dateValue) => {
    let date = new Date(dateValue);
    let splitted = date.toLocaleString().split(" ")[1].split(":").splice(0, 2);
    var newTime = [];
    splitted.map((x) => newTime.push(("0" + x).slice(-2)));
    let result = newTime.join(":");
    return result;
  };

  const onChangeDate = (date) => {
    setClickedDate(date.target.value);
    if (user?.role === ROLE.CANDIDATE) {
      candidateMeetignForm.setValue("meetingdate", date.target.value, { shouldValidate: true });
    }
    if (user?.role === ROLE.CARE_HOME) {
      setupMeetingForm.setValue("meetingdate", date.target.value, { shouldValidate: true });
    }
  };

  return (
      <>
        <div className="page-wrapper dashboard">
          <Scripts />
          <Header />
          {user?.role === ROLE.CANDIDATE && <CandidateSidebar />}
          {user?.role === ROLE.CARE_HOME && <CareHomeSidebar />}
          <section className="user-dashboard">
            <div className="dashboard-outer">
              <div className="upper-title-box">
                <h3>Meetings</h3>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <div className="ls-widget">
                    <div className="tabs-box">
                      <div className="widget-content">
                        <div className="default-tabs style-two tabs-box">
                          <ul className="tab-buttons clearfix">
                            {user?.role === ROLE.CARE_HOME && (
                                <li className="tab-btn active-btn" data-tab="#tab1">
                                  Carehome
                                </li>
                            )}
                            {user?.role === ROLE.CANDIDATE && (
                                <li className="tab-btn active-btn" data-tab="#tab2">
                                  Candidate
                                </li>
                            )}
                          </ul>

                          <div className="tabs-content" style={{ padding: "0 px !important" }}>
                            <div
                                className="tab active-tab animated fadeIn"
                                id="tab1"
                                style={{ display: user?.role === ROLE.CARE_HOME ? "block" : "none" }}
                            >
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="ls-widget">
                                    <div>
                                      <div className="widget-content-1">
                                        <div className="table-outer">
                                          <main className="calendar-contain">
                                            <div className="message-box info">
                                              <p style={{ width: "70%" }}>
                                                <span class="la la-info-circle"></span> Click on calendar date to view or setup an invite.
                                              </p>
                                            </div>

                                            <aside className="calendar__sidebar">
                                              <div className="sidebar__nav">
                                                <div className="option-box">
                                                  <ul className="option-list"></ul>
                                                </div>
                                              </div>
                                              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between',marginRight:"15px"}}>
                                                <h2 className="sidebar__heading">
                                                  {getWeekDay(clickedDate)}
                                                  <br />
                                                  {getMonthFull(clickedDate)} {getDate(clickedDate)}
                                                </h2>
                                                {meetingURL && meetingURL !== 'NA' && isAcceptedMeeting && (
                                                    <a
                                                        className="btn btn-primary"
                                                        href={`/#/video-meeting?meetingHash=${meetingURL}`}
                                                        style={{height: 'fit-content', marginLeft: '10px'}}
                                                    >
                                                      Join Meeting
                                                    </a>
                                                )}
                                              </div>
                                              <ul className="sidebar__list">
                                                {meetingDetailPerDate?.length > 0 && (
                                                    <li className="text-danger">
                                                      <span class="la la-info-circle"></span> Click on an event to display details.
                                                    </li>
                                                )}
                                                {meetingDetailPerDate?.map((listItem) => {
                                                  return (
                                                      <li className="sidebar__list-item">
                                                    <span className="list-item__time">
                                                      {getTimeFromDate(listItem.meetingDateTime)}
                                                    </span>{" "}
                                                        <div style={{ display: "flex" }}>
                                                          <div
                                                              style={{ cursor: "pointer", color: "#0d6efd" }}
                                                              onClick={() => { getMeetingById(listItem); }}
                                                          >
                                                            {listItem.toUserName}{" "}
                                                          </div>
                                                          <span
                                                              className={
                                                                listItem?.status === "Reschedule_Requested"
                                                                    ? "scheduled"
                                                                    : listItem?.status === "Completed"
                                                                        ? "accepted"
                                                                        : listItem.status.toLowerCase()
                                                              }
                                                          >
                                                        {listItem?.status?.split("_")?.join(" ")}
                                                      </span>
                                                        </div>
                                                      </li>
                                                  );
                                                })}
                                                {!isAcceptedMeeting && (
                                                    <li>
                                                      <button
                                                          className="theme-btn btn-sm btn-style-one large"
                                                          onClick={() => {
                                                            scrollTop(".setupMeetingTab");
                                                            $(".setupMeetingTab").trigger("click");
                                                          }}
                                                      >
                                                        Add New Meeting
                                                      </button>
                                                    </li>
                                                )}
                                              </ul>
                                            </aside>
                                            <section className="calendar__days">
                                              <FullCalendar
                                                  plugins={[dayGridPlugin, interactionPlugin]}
                                                  initialView="dayGridMonth"
                                                  dateClick={(e) => handleDateClick(e)}
                                                  events={meetingCountDetail}
                                                  eventContent={renderEventContent}
                                                  datesSet={(e) => {
                                                    const date = new Date(e.startStr);
                                                    let currentTime = new Date(date).getTime();
                                                    let updatedTIme = new Date(currentTime + 10 * 24 * 60 * 60 * 1000);
                                                    const month = Number(updatedTIme?.getMonth()) + 1;
                                                    const year = updatedTIme.getFullYear();
                                                    const payload = {
                                                      monthNumber: month,
                                                      year: year,
                                                    };
                                                    setCalendarMonthsDates(payload);
                                                    getMeetingCounts(payload);
                                                  }}
                                              />
                                            </section>
                                          </main>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="ls-widget">
                                    <div className="tabs-box">
                                      <ul className="accordion-box">
                                        {isCareHome && isAcceptedMeeting ? (
                                            <li className="accordion block active-block">
                                              <div className="acc-btn setupMeetingTab">
                                                {meetingDetailPerUser?.length > 0 ? 'Update Meeting' : 'Setup Meeting'}
                                                <span className="icon flaticon-add"></span>
                                              </div>
                                              <div className="acc-content" style={{ display: "none" }}>
                                                <div className="content">
                                                  <div className="widget-content-1">
                                                    <form
                                                        className="default-form"
                                                        onSubmit={setupMeetingForm.handleSubmit(
                                                            meetingDetailPerUser?.length > 0 ? UpdateMeetingInvite : sendMeetingInvite
                                                        )}
                                                        noValidate
                                                    >
                                                      <div className="row">
                                                        {meetingDetailPerUser?.length > 0 && (
                                                            <ul className="sidebar__list">
                                                              <li className="pb-2">
                  <span className={
                    meetingDetailPerUser[0]?.status === "Reschedule_Requested"
                        ? "scheduled"
                        : meetingDetailPerUser[0]?.status?.toLowerCase()
                  }>
                    {meetingDetailPerUser[0]?.status?.split("_")?.join(" ")}
                  </span>
                                                              </li>
                                                            </ul>
                                                        )}

                                                        {/* Job Title Field */}
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Job Title</label>
                                                          {meetingDetailPerUser?.length > 0 ? (
                                                              <input
                                                                  type="text"
                                                                  value={jobVal?.title || ""}
                                                                  readOnly
                                                                  className="read-only-field"
                                                              />
                                                          ) : (
                                                              <Autocomplete
                                                                  disablePortal
                                                                  id="combo-box-demo"
                                                                  {...setupMeetingForm.register("searchActiveJobs", {
                                                                    required: { value: true, message: "required" },
                                                                  })}
                                                                  value={jobVal}
                                                                  options={jobs ? jobs : []}
                                                                  getOptionLabel={(option) => option.title}
                                                                  onChange={(_, newValue) => {
                                                                    setupMeetingForm.setValue("searchActiveJobs", newValue, {
                                                                      shouldValidate: true,
                                                                    });
                                                                    setJobval(newValue);
                                                                    getCandidateByUser(newValue?.id);
                                                                  }}
                                                                  renderInput={(params) => (
                                                                      <TextField {...params} label="Search Active Job" />
                                                                  )}
                                                              />
                                                          )}
                                                          {errors?.searchActiveJobs && (
                                                              <InputError message={errors?.searchActiveJobs?.message} />
                                                          )}
                                                        </div>

                                                        {/* Candidate Name Field */}
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Candidate Name</label>
                                                          {meetingDetailPerUser?.length > 0 ? (
                                                              <input
                                                                  type="text"
                                                                  value={userVal?.name || ""}
                                                                  readOnly
                                                                  className="read-only-field"
                                                              />
                                                          ) : (
                                                              <Autocomplete
                                                                  disablePortal
                                                                  id="combo-box-demo"
                                                                  {...setupMeetingForm.register("searchCandidate", {
                                                                    required: { value: true, message: "required" },
                                                                  })}
                                                                  options={users}
                                                                  defaultValue={userVal}
                                                                  value={userVal}
                                                                  getOptionLabel={(option) => option.name}
                                                                  onChange={(_, newValue) => {
                                                                    setupMeetingForm.setValue("searchCandidate", newValue, {
                                                                      shouldValidate: true,
                                                                    });
                                                                    setUserval(newValue);
                                                                  }}
                                                                  renderInput={(params) => (
                                                                      <TextField {...params} label="Search Candidates" />
                                                                  )}
                                                              />
                                                          )}
                                                          {errors?.searchCandidate && (
                                                              <InputError message={errors?.searchCandidate?.message} />
                                                          )}
                                                        </div>

                                                        {/* Meeting Notes */}
                                                        <div className="form-group col-lg-12 col-md-12">
                                                          <label>Add notes for applicant</label>
                                                          <textarea
                                                              style={{ minHeight: "160px" }}
                                                              name={"meetingDescription"}
                                                              {...setupMeetingForm.register("meetingDescription")}
                                                              placeholder="Add information for the potential candidate"
                                                          ></textarea>
                                                        </div>

                                                        {descriptionVal?.length > 0 && (
                                                            <div className="form-group job-detail col-lg-12 col-md-12">
                                                              <label>Job Description</label>
                                                              <p>{descriptionVal}</p>
                                                            </div>
                                                        )}

                                                        {/* Meeting Date */}
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Meeting Date</label>
                                                          <input
                                                              type="date"
                                                              name="meetingdate"
                                                              required
                                                              min={formatDateHyphen(new Date())}
                                                              {...setupMeetingForm.register("meetingdate", {
                                                                required: { value: true, message: "required" },
                                                              })}
                                                          />
                                                          {errors?.meetingdate && (
                                                              <InputError message={errors?.meetingdate?.message} />
                                                          )}
                                                        </div>

                                                        {/* Meeting Time */}
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Meeting Start Time</label>
                                                          <TimePicker
                                                              value={timeValue}
                                                              onChange={(value) => {
                                                                setTimeValue(value);
                                                                const formattedTime = `${value}:00.000Z`;
                                                                setupMeetingForm.setValue("meetingtime", formattedTime);
                                                              }}
                                                              error={errors?.meetingtime}
                                                              name="meetingtime"
                                                              required
                                                          />
                                                          {errors?.meetingtime && (
                                                              <InputError message={errors?.meetingtime?.message} />
                                                          )}
                                                        </div>

                                                        {/* Meeting Type */}
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Meeting Type</label>
                                                          <select
                                                              {...setupMeetingForm.register("meetingType")}
                                                              name="meetingType"
                                                              className="chosen-select-meetingType"
                                                          >
                                                            <option value={""}>Select</option>
                                                            <option value={"TELECON"}>Telephone</option>
                                                            <option value={"IN_PERSON"}>In Person</option>
                                                            <option value={"VIDEO_CALL"}>Video Call</option>
                                                          </select>
                                                        </div>

                                                        {/* Rejection Comments - Only shown for accepted meetings */}
                                                        {meetingDetailPerUser[0]?.status === "Accepted" && (
                                                            <div className="form-group col-lg-12 col-md-12">
                                                              <label>Rejection Comments (Optional)</label>
                                                              <textarea
                                                                  style={{ minHeight: "100px" }}
                                                                  name="rejectionComments"
                                                                  {...setupMeetingForm.register("rejectionComments")}
                                                                  placeholder="Enter reason for rejection (visible to candidate)"
                                                              ></textarea>
                                                            </div>
                                                        )}

                                                        {/* Status Messages */}
                                                        <div className="form-group col-lg-12 col-md-12">
                                                          <div className="row">
                                                            <div className="col-md-12">
                                                              {sentInviteFlag === "success" && (
                                                                  <Success msg={`You have successfully set up a meeting.`} />
                                                              )}
                                                              {acceptRejectStatus === "success" && (
                                                                  <Success msg={`You have successfully updated your meeting.`} />
                                                              )}
                                                              {acceptRejectStatus === "error" && (
                                                                  <Error msg={`Something went wrong while set up a meeting. Please try again.`} />
                                                              )}
                                                              {sentInviteFlag === "error" && (
                                                                  <Error msg={`Something went wrong while set up a meeting. Please try again.`} />
                                                              )}
                                                              {deleteMeetingStatus === "success" && (
                                                                  <Success msg={`Your meeting has been successfully deleted.`} />
                                                              )}
                                                              {deleteMeetingStatus === "error" && (
                                                                  <Error msg={`Something went wrong while deleting a meeting. Please try again.`} />
                                                              )}
                                                            </div>
                                                          </div>

                                                          {/* Action Buttons */}
                                                          <div className="buttons">
                                                            {isLoading && <Loader />}
                                                            {!isLoading && (
                                                                <div className="meeting buttons">
                                                                  {/* Update/Send Invite Button */}
                                                                  <button
                                                                      type="submit"
                                                                      className="theme-btn btn-style-one large"
                                                                      onClick={() => {
                                                                        setupMeetingForm.setValue("submitValue", {
                                                                          action: meetingDetailPerUser?.length > 0
                                                                              ? "UPDATE_MEETING"
                                                                              : "SEND_INVITE",
                                                                          status: "Accepted",
                                                                        });
                                                                      }}
                                                                  >
                                                                    {meetingDetailPerUser?.length > 0 ? "Update Meeting" : "Send Invite"}
                                                                  </button>

                                                                  {/* Delete Meeting Button */}
                                                                  {(meetingDetailPerUser[0]?.status === "Scheduled" ||
                                                                      meetingDetailPerUser[0]?.status === "Reschedule_Requested") && (
                                                                      <button
                                                                          type="button"
                                                                          className="theme-btn btn-style-nine large"
                                                                          onClick={() => {
                                                                            deleteMeeting();
                                                                          }}
                                                                      >
                                                                        Delete Meeting
                                                                      </button>
                                                                  )}

                                                                  {/* Candidate Action Buttons */}
                                                                  {meetingDetailPerUser[0]?.status === "Accepted" && (
                                                                      <>
                                                                        <button
                                                                            type="submit"
                                                                            className="theme-btn btn-style-seven"
                                                                            onClick={() => {
                                                                              setupMeetingForm.setValue("submitValue", {
                                                                                action: "SELECT_CANDIDATE",
                                                                                status: "Completed",
                                                                              });
                                                                            }}
                                                                        >
                                                                          Select Candidate
                                                                        </button>
                                                                        <button
                                                                            type="submit"
                                                                            className="theme-btn btn-style-nine "
                                                                            onClick={() => {
                                                                              setupMeetingForm.setValue("submitValue", {
                                                                                action: "REJECT_CANDIDATE",
                                                                                status: "Completed",
                                                                              });
                                                                            }}
                                                                        >
                                                                          Reject Candidate
                                                                        </button>
                                                                      </>
                                                                  )}
                                                                </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </li>
                                        ) : (
                                            <li className="accordion block active-block">
                                              <div className="acc-btn setupMeetingTab">
                                                Setup Meeting <span className="icon flaticon-add"></span>
                                              </div>
                                              <div className="acc-content" style={{ display: "none" }}>
                                                <div className="content">
                                                  <div className="widget-content-1">
                                                    <form
                                                        className="default-form"
                                                        onSubmit={setupMeetingForm.handleSubmit(
                                                            meetingDetailPerUser?.length > 0
                                                                ? UpdateMeetingInvite
                                                                : sendMeetingInvite
                                                        )}
                                                        noValidate
                                                    >
                                                      <div className="row">
                                                        {meetingDetailPerUser?.length > 0 && (
                                                            <ul className="sidebar__list">
                                                              <li className="pb-2">
                                                          <span
                                                              className={
                                                                meetingDetailPerUser[0]?.status === "Reschedule_Requested"
                                                                    ? "scheduled"
                                                                    : meetingDetailPerUser[0]?.status?.toLowerCase()
                                                              }
                                                          >
                                                            {meetingDetailPerUser[0]?.status?.split("_")?.join(" ")}
                                                          </span>
                                                              </li>
                                                            </ul>
                                                        )}
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Job Title</label>
                                                          <Autocomplete
                                                              disablePortal
                                                              id="combo-box-demo"
                                                              {...setupMeetingForm.register("searchActiveJobs", {
                                                                required: { value: true, message: "required" },
                                                              })}
                                                              value={jobVal}
                                                              options={jobs ? jobs : []}
                                                              getOptionLabel={(option) => option.title}
                                                              onChange={(_, newValue) => {
                                                                setupMeetingForm.setValue("searchActiveJobs", newValue, {
                                                                  shouldValidate: true,
                                                                });
                                                                setJobval(newValue);
                                                                getCandidateByUser(newValue?.id);
                                                              }}
                                                              renderInput={(params) => (
                                                                  <TextField {...params} label="Search Active Job" />
                                                              )}
                                                          />
                                                          {errors?.searchActiveJobs && (
                                                              <InputError message={errors?.searchActiveJobs?.message} />
                                                          )}
                                                        </div>
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Candidate Name</label>
                                                          <Autocomplete
                                                              disablePortal
                                                              id="combo-box-demo"
                                                              {...setupMeetingForm.register("searchCandidate", {
                                                                required: { value: true, message: "required" },
                                                              })}
                                                              options={users}
                                                              defaultValue={userVal}
                                                              value={userVal}
                                                              getOptionLabel={(option) => option.name}
                                                              onChange={(_, newValue) => {
                                                                setupMeetingForm.setValue("searchCandidate", newValue, {
                                                                  shouldValidate: true,
                                                                });
                                                                setUserval(newValue);
                                                              }}
                                                              renderInput={(params) => (
                                                                  <TextField {...params} label="Search Candidates" />
                                                              )}
                                                          />
                                                          {errors?.searchCandidate && (
                                                              <InputError message={errors?.searchCandidate?.message} />
                                                          )}
                                                        </div>
                                                        <div className="form-group col-lg-12 col-md-12">
                                                          <label>Add notes for applicant</label>
                                                          <textarea
                                                              style={{ minHeight: "160px" }}
                                                              name={"meetingDescription"}
                                                              {...setupMeetingForm.register("meetingDescription")}
                                                              placeholder="Add information for the potential candidate such as any pre-requisites, address, documents to bring, etc."
                                                          ></textarea>
                                                        </div>

                                                        {descriptionVal?.length > 0 && (
                                                            <div className="form-group job-detail col-lg-12 col-md-12">
                                                              <label>Job Description</label>
                                                              <p>{descriptionVal}</p>
                                                            </div>
                                                        )}

                                                        <div className="message-box info">
                                                          <p>
                                                            Please note: All meetings will be set up for 30 minutes only.
                                                          </p>
                                                        </div>

                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Meeting Date</label>
                                                          <input
                                                              type="date"
                                                              name="meetingdate"
                                                              placeholder=""
                                                              required
                                                              min={formatDateHyphen(new Date())}
                                                              onChange={(e) => onChangeDate(e)}
                                                              {...setupMeetingForm.register("meetingdate", {
                                                                required: { value: true, message: "required" },
                                                              })}
                                                          />
                                                          {errors?.meetingdate && (
                                                              <InputError message={errors?.meetingdate?.message} />
                                                          )}
                                                        </div>

                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Meeting Start Time</label>
                                                          <TimePicker
                                                              value={timeValue}
                                                              onChange={(value) => {
                                                                setTimeValue(value);
                                                                const formattedTime = `${value}:00.000Z`;
                                                                setupMeetingForm.setValue("meetingtime", formattedTime);
                                                              }}
                                                              error={errors?.meetingtime}
                                                              name="meetingtime"
                                                              required
                                                          />
                                                          {errors?.meetingtime && (
                                                              <InputError message={errors?.meetingtime?.message} />
                                                          )}
                                                        </div>
                                                        <div className="form-group col-lg-6 col-md-12">
                                                          <label>Meeting Type</label>
                                                          <select
                                                              {...setupMeetingForm.register("meetingType")}
                                                              name="meetingType"
                                                              className="chosen-select-meetingType"
                                                          >
                                                            <option value={""}>Select</option>
                                                            <option value={"TELECON"}>Telephone</option>
                                                            <option value={"IN_PERSON"}>In Person</option>
                                                            <option value={"VIDEO_CALL"}>Video Call</option>
                                                          </select>
                                                        </div>

                                                        <div className="form-group col-lg-12 col-md-12">
                                                          <div className="row">
                                                            <div className="col-md-12">
                                                              {sentInviteFlag === "success" && (
                                                                  <Success msg={`You have successfully set up a meeting.`} />
                                                              )}
                                                              {acceptRejectStatus === "success" && (
                                                                  <Success msg={`You have successfully updated your meeting.`} />
                                                              )}
                                                              {acceptRejectStatus === "error" && (
                                                                  <Error msg={`Something went wrong while set up a meeting. Please try again.`} />
                                                              )}
                                                              {sentInviteFlag === "error" && (
                                                                  <Error msg={`Something went wrong while set up a meeting. Please try again.`} />
                                                              )}
                                                              {deleteMeetingStatus === "success" && (
                                                                  <Success msg={`Your meeting has been successfully deleted.`} />
                                                              )}
                                                              {deleteMeetingStatus === "error" && (
                                                                  <Error msg={`Something went wrong while deleting a meeting. Please try again.`} />
                                                              )}
                                                            </div>
                                                          </div>
                                                          <div className="buttons">
                                                            {isLoading && <Loader />}
                                                            {!isLoading && (
                                                                <div className="meeting buttons">
                                                                  <button
                                                                      type="submit"
                                                                      disabled={meetingUserStatus === "Completed"}
                                                                      className="theme-btn btn-style-one large"
                                                                      onClick={() => {
                                                                        setupMeetingForm.setValue("submitValue", {
                                                                          action: "SEND_INVITE",
                                                                          status: "Reschedule_Requested",
                                                                        });
                                                                      }}
                                                                  >
                                                                    Send Invite
                                                                  </button>
                                                                  {meetingDetailPerUser?.length > 0
                                                                      ? (meetingDetailPerUser[0]?.status === "Scheduled" ||
                                                                      meetingDetailPerUser[0]?.status === "Reschedule_Requested") && (
                                                                      <button
                                                                          type="button"
                                                                          className="theme-btn btn-style-nine large"
                                                                          onClick={() => {
                                                                            deleteMeeting();
                                                                          }}
                                                                      >
                                                                        Delete Meeting
                                                                      </button>
                                                                  )
                                                                      : ""}
                                                                </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </form>
                                                  </div>
                                                </div>
                                              </div>
                                            </li>
                                        )}

                                        <li className="accordion block">
                                          <div className="acc-btn addMeetingNoteSection">
                                            Add Meeting Minutes <span className="icon flaticon-add"></span>
                                          </div>
                                          <div className="acc-content current" style={{ display: "none" }}>
                                            <div className="content">
                                              <form
                                                  className="default-form"
                                                  onSubmit={setupMeetingForm.handleSubmit(UpdateMeetingInvite)}
                                                  noValidate
                                              >
                                                <div className="row">
                                                  <div className="message-box warning">
                                                    <p>
                                                      Make sure the meeting has concluded before adding comments and taking action.
                                                    </p>
                                                  </div>

                                                  <div className="form-group col-lg-6 col-md-12">
                                                    <label>Candidate Name</label>
                                                    {meetingDetailPerUser?.length > 0 && (
                                                        <p>{meetingDetailPerUser[0]?.toUserName}</p>
                                                    )}
                                                  </div>

                                                  <div className="form-group col-lg-6 col-md-12">
                                                    <label>Job Title</label>
                                                    <p>{jobVal?.title}</p>
                                                  </div>

                                                  <div className="form-group col-lg-12 col-md-12">
                                                    <label>Meeting Minutes</label>
                                                    <textarea
                                                        style={{ minHeight: "160px" }}
                                                        value={meetingNotes}
                                                        name={"meetingNotes"}
                                                        {...register("meetingNotes")}
                                                        onChange={(e) => setMeetingNotes(e.target.value)}
                                                        placeholder="Enter Meeting Minutes"
                                                    ></textarea>
                                                  </div>
                                                  <div className="form-group col-lg-12 col-md-12">
                                                    <label>Rejection Comments (Optional)</label>
                                                    <textarea
                                                        style={{ minHeight: "100px" }}
                                                        name="rejectionComments"
                                                        {...setupMeetingForm.register("rejectionComments")}
                                                        placeholder="Enter reason for rejection (visible to candidate)"
                                                    ></textarea>
                                                  </div>
                                                  <div className="form-group col-lg-6 col-md-12">
                                                    <label>Joining Date</label>
                                                    <input
                                                        type="date"
                                                        name="joiningDate"
                                                        placeholder=""
                                                        required
                                                        {...setupMeetingForm.register("joiningDate")}
                                                    />
                                                  </div>
                                                  <div className="form-group col-lg-6 col-md-12">
                                                    <label>Reporting Time</label>
                                                    <input
                                                        type="time"
                                                        name="reportingTime"
                                                        step="1800"
                                                        placeholder=""
                                                        required
                                                        {...setupMeetingForm.register("reportingTime")}
                                                    />
                                                  </div>

                                                  <div className="form-group col-lg-12 col-md-12">
                                                    {acceptRejectStatus === "success" && (
                                                        <Success msg={`Successfully updated the response.`} />
                                                    )}
                                                    {acceptRejectStatus === "error" && (
                                                        <Error msg={`Something went wrong while updating response. please try again.`} />
                                                    )}
                                                    {jobApplicationStatus === "validationError" && (
                                                        <Error msg={`Please fill all the required fields.`} />
                                                    )}
                                                    {jobApplicationStatus === "error" && (
                                                        <Error msg={`Something went wrong while updating job application. Please try again.`} />
                                                    )}
                                                    {jobApplicationStatus === "success" && (
                                                        <Success msg={`Successfully selected the employee.`} />
                                                    )}
                                                    {isLoading && <Loading />}
                                                    {!isLoading && (
                                                        <div className="meeting buttons">
                                                          <button
                                                              type="submit"
                                                              disabled={meetingUserStatus === "Completed"}
                                                              name="submit-result"
                                                              className="theme-btn btn-style-seven large"
                                                              onClick={() => {
                                                                setupMeetingForm.setValue("submitValue", {
                                                                  action: "SELECT_CANDIDATE",
                                                                  status: "Completed",
                                                                });
                                                              }}
                                                          >
                                                            Select Candidate
                                                          </button>
                                                          <button
                                                              type="submit"
                                                              name="submit-result"
                                                              disabled={meetingUserStatus === "Completed"}
                                                              className="theme-btn btn-style-nine large"
                                                              onClick={() => {
                                                                setupMeetingForm.setValue("submitValue", {
                                                                  action: "REJECT_CANDIDATE",
                                                                  status: "Completed",
                                                                });
                                                              }}
                                                          >
                                                            Reject Candidate
                                                          </button>
                                                        </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </form>
                                            </div>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                                className="tab"
                                id="tab2"
                                style={{ display: user?.role === ROLE.CANDIDATE ? "block" : "none" }}
                            >
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="ls-widget">
                                    <div>
                                      <div className="widget-content-1">
                                        <div className="table-outer">
                                          <main className="calendar-contain">
                                            <div className="message-box info">
                                              <p style={{ width: "70%" }}>
                                                <span class="la la-info-circle"></span> Click on calendar date to view or update an invite.
                                              </p>
                                            </div>

                                            <aside className="calendar__sidebar">
                                              <div className="sidebar__nav">
                                                <div className="option-box"></div>
                                              </div>
                                              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight:"15px"}}>
                                                <h2 className="sidebar__heading">
                                                  {getWeekDay(clickedDate)}
                                                  <br />
                                                  {getMonthFull(clickedDate)} {getDate(clickedDate)}
                                                </h2>
                                                {meetingURL && meetingURL !== 'NA' && isAcceptedMeeting && (
                                                    <a
                                                        className="btn btn-primary"
                                                        href={`/#/video-meeting?meetingHash=${meetingURL}`}
                                                        style={{height: 'fit-content', marginLeft: '10px'}}
                                                    >
                                                      Join Meeting
                                                    </a>
                                                )}
                                              </div>

                                              <ul className="sidebar__list">
                                                {meetingDetailPerDate?.length > 0 && (
                                                    <li className="text-danger">
                                                      <span class="la la-info-circle"></span> Click on an event to display details.
                                                    </li>
                                                )}
                                                {meetingDetailPerDate?.map((listItem, index) => {
                                                  return (
                                                      <li className="sidebar__list-item">
                                                    <span className="list-item__time" >
                                                      {getTimeFromDate(listItem.meetingDateTime)}
                                                    </span>
                                                        {"   "}
                                                        <span
                                                            style={{ cursor: "pointer", color: "#0d6efd" }}
                                                            onClick={() => getMeetingById(listItem)}
                                                        >
                                                      {listItem.companyName
                                                          ? listItem.companyName
                                                          : listItem.fromUserName}{" "}
                                                    </span>
                                                        <span
                                                            className={
                                                              listItem?.status === "Reschedule_Requested"
                                                                  ? "scheduled"
                                                                  : listItem?.status === "Completed"
                                                                      ? "accepted"
                                                                      : listItem.status.toLowerCase()
                                                            }
                                                        >
                                                      {listItem?.status.replace("_", " ")}
                                                    </span>
                                                      </li>
                                                  );
                                                })}
                                              </ul>
                                            </aside>
                                            <section className="calendar__days">
                                              <FullCalendar
                                                  plugins={[dayGridPlugin, interactionPlugin]}
                                                  initialView="dayGridMonth"
                                                  dateClick={(e) => handleDateClick(e)}
                                                  events={meetingCountDetail}
                                                  eventContent={renderEventContent}
                                                  datesSet={(e) => {
                                                    const date = new Date(e.startStr);
                                                    let currentTime = new Date(date).getTime();
                                                    let updatedTIme = new Date(currentTime + 10 * 24 * 60 * 60 * 1000);
                                                    const month = Number(updatedTIme?.getMonth()) + 1;
                                                    const year = updatedTIme.getFullYear();
                                                    const payload = {
                                                      monthNumber: month,
                                                      year: year,
                                                    };
                                                    setCalendarMonthsDates(payload);
                                                    getMeetingCounts(payload);
                                                  }}
                                              />
                                            </section>
                                          </main>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="ls-widget view-schedule-candidate-section">
                                    <div className="tabs-box">
                                      <div className="widget-meeting-title">
                                        <h4>Join Meeting</h4>
                                      </div>

                                      <div className="widget-content-1">
                                        <form
                                            className="default-form"
                                            onSubmit={candidateMeetignForm.handleSubmit(UpdateMeetingInvite)}
                                            noValidate
                                        >
                                          <div className="row">
                                            <div className="form-group col-lg-6 col-md-12">
                                              <label>Carehome Name</label>
                                              <input
                                                  type="text"
                                                  name="candidate"
                                                  placeholder=""
                                                  disabled
                                                  readonly
                                                  {...candidateMeetignForm.register("candidate", {
                                                    required: { value: true, message: "required" },
                                                  })}
                                              />
                                              {candidateError?.candidate && (
                                                  <InputError message={candidateError?.candidate?.message} />
                                              )}
                                            </div>

                                            <div className="form-group col-lg-6 col-md-12">
                                              <label>Job Title</label>
                                              <input
                                                  type="text"
                                                  name="job"
                                                  placeholder=""
                                                  disabled
                                                  readonly
                                                  {...candidateMeetignForm.register("job", {
                                                    required: { value: true, message: "required" },
                                                  })}
                                              />
                                              {candidateError?.job && (
                                                  <InputError message={candidateError?.job?.message} />
                                              )}
                                            </div>
                                            <div className="form-group col-lg-6 col-md-12">
                                              <label>Meeting Type</label>
                                              <input
                                                  type="text"
                                                  name="meetingType"
                                                  placeholder=""
                                                  disabled
                                                  readonly
                                                  {...candidateMeetignForm.register("meetingType")}
                                              />
                                            </div>

                                            <div className="form-group col-lg-12 col-md-12">
                                              <label>Notes to Applicant</label>
                                              <textarea
                                                  style={{ minHeight: "160px" }}
                                                  placeholder=""
                                                  disabled
                                                  readonly
                                                  name={"meetingDescription"}
                                                  {...candidateMeetignForm.register("meetingDescription")}
                                              ></textarea>
                                            </div>

                                            <div className="form-group job-detail col-lg-12 col-md-12">
                                              <label>Job Description</label>
                                              <p style={{ fontSize:"large", fontWeight:"bold"}}>{descriptionVal}</p>
                                            </div>

                                            <div className="message-box info" style={{ paddingLeft: "2%" }}>
                                              <p>
                                                Please note: All meetings are for 30 minutes only.
                                              </p>
                                            </div>

                                            <div className="form-group col-lg-6 col-md-12">
                                              <label>Meeting Date</label>
                                              <input
                                                  type="date"
                                                  name="meetingdate"
                                                  placeholder=""
                                                  required
                                                  onChange={(e) => onChangeDate(e)}
                                                  {...candidateMeetignForm.register("meetingdate", {
                                                    required: { value: true, message: "required" },
                                                  })}
                                              />
                                              {candidateError?.meetingdate && (
                                                  <InputError message={candidateError?.meetingdate?.message} />
                                              )}
                                            </div>

                                            <div className="form-group col-lg-6 col-md-12">
                                              <label>Meeting Start Time</label>
                                              <input
                                                  type="time"
                                                  name="meetingtime"
                                                  step="1800"
                                                  disabled
                                                  required
                                                  value={meetingDetailPerUser[0]?.meetingDateTime ?
                                                      getTimeFromDate(meetingDetailPerUser[0].meetingDateTime, 'input') :
                                                      ''}
                                              />
                                              {errors?.meetingtime && (
                                                  <InputError
                                                      message={
                                                        errors?.meetingtime
                                                            ?.message
                                                      }
                                                      key={
                                                        errors?.meetingtime
                                                            ?.message
                                                      }
                                                  />
                                              )}
                                            </div>
                                            <div>
                                              <div className="checkbox-outer">
                                                <ul className="checkboxes square">
                                                  <li>
                                                    <input
                                                        id="check-candidate-confirm"
                                                        type="checkbox"
                                                        name="candidateConfirmCheck"
                                                        value={"Yes"}
                                                        {...candidateMeetignForm.register("candidateConfirmCheck", {
                                                          required: { value: true, message: "required" },
                                                        })}
                                                    />
                                                    <label htmlFor="check-candidate-confirm">
                                                      Have you checked the date and time before taking the action ?
                                                    </label>
                                                    {candidateError?.candidateConfirmCheck && (
                                                        <InputError
                                                            message={candidateError?.candidateConfirmCheck?.message}
                                                        />
                                                    )}
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>

                                            <div className="form-group col-lg-12 col-md-12 text-right">
                                              <div className="form-group col-lg-12 col-md-12">
                                                {acceptRejectStatus === "success" && (
                                                    <Success msg={`Successfully updated the response.`} />
                                                )}
                                                {acceptRejectStatus === "error" && (
                                                    <Error msg={`Something went wrong while updating response. please try again.`} />
                                                )}
                                                {isLoading && <Loading />}
                                                {!isLoading && (
                                                    <div className="meeting buttons">
                                                      {/* Only show Accept button if meeting is not already accepted */}
                                                      {meetingDetailPerUser[0]?.status !== "Accepted" && (
                                                          <button
                                                              type="submit"
                                                              disabled={meetingUserStatus === "Completed"}
                                                              onClick={() => {
                                                                candidateMeetignForm.setValue("submitValue", {
                                                                  action: "ACCEPT_INVITE",
                                                                  status: "Accepted",
                                                                });
                                                              }}
                                                              className="theme-btn btn-style-seven large"
                                                          >
                                                            Accept Invite
                                                          </button>
                                                      )}

                                                      {/* Always show Reschedule button if meeting isn't completed */}
                                                      <button
                                                          type="submit"
                                                          disabled={meetingUserStatus === "Completed"}
                                                          onClick={() => {
                                                            candidateMeetignForm.setValue("submitValue", {
                                                              action: "REQUEST_RESCHEDULE",
                                                              status: "Reschedule_Requested",
                                                            });
                                                          }}
                                                          className="theme-btn btn-style-two large"
                                                      >
                                                        Request Reschedule
                                                      </button>

                                                      {/* Show Reject button if meeting isn't accepted or completed */}
                                                          <button
                                                              type="submit"
                                                              disabled={meetingUserStatus === "Completed"}
                                                              onClick={() => {
                                                                candidateMeetignForm.setValue("submitValue", {
                                                                  action: "REJECT_INVITE",
                                                                  status: "Declined",
                                                                });
                                                              }}
                                                              className="theme-btn btn-style-nine large"
                                                          >
                                                            Reject Invite
                                                          </button>
                                                      
                                                    </div>                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </>
  );
};

export default Meetings;